import { Injectable, inject } from "@angular/core";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import {
	LimitOrderQueryParamName,
	LimitOrderRouteName,
	OrdersQueryParamsCollection
} from "../interfaces/limit-orders-route.interface";
import { ActivatedRoute, Router, UrlTree } from "@angular/router";
import { of, Observable } from "rxjs";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";

@Injectable({ providedIn: "root" })
export class LimitOrderNavigationFacade {
	private router = inject(Router);
	private activateRoute = inject(ActivatedRoute);
	private unviversalModalService = inject(UniversalModalService);

	getQueryParams$: Observable<Partial<OrdersQueryParamsCollection>> = this.activateRoute.queryParams;

	gotoByNavigation(
		path: LimitOrderRouteName,
		queryParams?: Partial<OrdersQueryParamsCollection>,
		handleQueryParams = false
	): Promise<boolean> {
		let queryParamsHandling = null;
		if (handleQueryParams) {
			queryParamsHandling = "merge";
		}

		return this.router.navigate(
			[{ outlets: { [ROUTER_OUTLET_NAME]: [LimitOrderRouteName.LimitOrderList, path] } }],
			{
				queryParams,
				queryParamsHandling: queryParamsHandling
			}
		);
	}

	gotoRootNavigationAndCloseModal(): Promise<boolean> {
		this.closeModal();
		return this.router.navigate([{ outlets: { [ROUTER_OUTLET_NAME]: null } }]);
	}

	goToOrderListAssetPid(assetPid?: string, filterType?: string): Promise<boolean> {
		const queryParams: Partial<OrdersQueryParamsCollection> = {
			[LimitOrderQueryParamName.AssetdPid]: assetPid,
			[LimitOrderQueryParamName.FilterType]: filterType
		};
		return this.router.navigate([LimitOrderRouteName.LimitOrderList], {
			queryParams
		});
	}

	goToOrderList(filterType: string): Promise<boolean> {
		const queryParams: Partial<OrdersQueryParamsCollection> = {
			[LimitOrderQueryParamName.FilterType]: filterType
		};
		return this.router.navigate([LimitOrderRouteName.LimitOrderList], {
			queryParams
		});
	}

	gotoByUrlTree(path: LimitOrderRouteName, queryParams?: Partial<OrdersQueryParamsCollection>): UrlTree {
		return this.router.createUrlTree(
			[{ outlets: { [ROUTER_OUTLET_NAME]: [LimitOrderRouteName.LimitOrderList, path] } }],
			{
				queryParams
			}
		);
	}

	gotoNotFound$(): Observable<UrlTree> {
		return of(this.gotoByUrlTree(LimitOrderRouteName.NotFound));
	}

	returnToOrderAmount$(qry: Partial<OrdersQueryParamsCollection>): Observable<UrlTree> {
		return of(this.gotoByUrlTree(LimitOrderRouteName.LimitOrderAmount, qry));
	}

	async closeModal(): Promise<void> {
		this.unviversalModalService.close(ModalCloseReason.close);
	}

	openDepositModal(): Promise<boolean> {
		return this.router.navigate([{ outlets: { [ROUTER_OUTLET_NAME]: ["fiat-deposit", "select-deposit-type"] } }]);
	}

	routeParamsReader(): Observable<Partial<OrdersQueryParamsCollection>> {
		return this.getQueryParams$;
	}

	getRoute(): string {
		return this.router.url;
	}

	gotoRootNavigation(path: string): Promise<boolean> {
		return this.router.navigateByUrl(path);
	}
}
